/**
 * Admin Inspector Formatter feature gating.
 *
 * This is a client-only tool for trusted admins. It must be explicitly enabled
 * via feature flag in the build environment.
 *
 * Security note:
 * - This check is for UI gating only. It does NOT replace server-side auth.
 * - We use either an explicit email allowlist (strongest "only me" control), or
 *   fall back to `isAdmin` from GET /auth/me (Cognito Admins group).
 */

export const ADMIN_INSPECTOR_FEATURE_ENABLED =
  String(process.env.REACT_APP_FEATURE_ADMIN_INSPECTOR || '').trim() === '1';

function parseEmailList(raw) {
  return String(raw || '')
    .split(',')
    .map((s) => s.trim().toLowerCase())
    .filter(Boolean);
}

export function getAdminInspectorAllowedEmails() {
  return parseEmailList(process.env.REACT_APP_ADMIN_INSPECTOR_EMAILS || '');
}

export function isAdminInspectorAllowed(currentUser) {
  if (!ADMIN_INSPECTOR_FEATURE_ENABLED) return false;
  if (!currentUser) return false;

  const allow = getAdminInspectorAllowedEmails();
  if (allow.length > 0) {
    const email = String(currentUser.email || '').trim().toLowerCase();
    return !!email && allow.includes(email);
  }

  return !!currentUser.isAdmin;
}
